import React, { useState } from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import { FaTrash } from "react-icons/fa";
export default function CartPage() {
    const sampleCart = [
        { id: 1, name: "Red T-Shirt", price: 25, image: "https://picsum.photos/200/200?1", qty: 1 },
        { id: 2, name: "Blue Jeans", price: 45, image: "https://picsum.photos/200/200?2", qty: 2 },
        { id: 3, name: "Running Shoes", price: 60, image: "https://picsum.photos/200/200?3", qty: 1 },
    ];
    const [cartItems, setCartItems] = useState(sampleCart);
    const removeItem = (id) => {
        setCartItems(cartItems.filter((item) => item.id !== id));
    };
    const updateQty = (id, qty) => {
        setCartItems(
            cartItems.map((item) => (item.id === id ? { ...item, qty: qty } : item))
        );
    };
    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);
    return (
        <div>
            <Header />
            <div className="cart-container">
                <h2 style={{ width: "100%", textAlign: "center" }}>My Cart</h2>
                <div className="gradient-line"></div>
                {cartItems.length === 0 ? (
                    <p className="empty-msg">Your cart is empty!</p>
                ) : (
                    <>
                        <div className="cart-grid">
                            {cartItems.map((item) => (
                                <div key={item.id} className="cart-card">
                                    <img src={item.image} alt={item.name} />
                                    <div className="cart-info">
                                        <p className="product-name">{item.name}</p>
                                        <p className="product-price">₹{item.price}</p>
                                        <div className="cart-qty">
                                            <label className="product-price">Qty: </label>
                                            <input
                                                className="product-price"
                                                type="number"
                                                min="1"
                                                value={item.qty}
                                                onChange={(e) => updateQty(item.id, parseInt(e.target.value))} />
                                        </div>
                                        <button className="remove-btn" onClick={() => removeItem(item.id)}>
                                            <FaTrash /> Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="cart-summary">
                            <p>Subtotal: <strong>₹{subtotal.toFixed(2)}</strong></p>
                            <button className="checkout-btn">Proceed to Checkout</button>
                        </div>
                    </>
                )}
            </div>
            <Footer />
        </div>
    )
}